export const header = {
  nav_home: "Home",
  nav_about: "About Us",
  nav_services: "Services",
  nav_partnership: "Partnership",
  nav_contact: "Contact",
  logo_tagline: "linking people & business",
};

export const brand = {
  tagline_linking: "Linking People & Business",
  tagline_excellence: "Driving to excellence with excellent drivers …",
};

export const hero = {
  slide1_title: "New markets, new business ... no risk!",
  slide2_title: "With us straight into the heart of Europe!",
  slide3_title: "Germany (DACH) – Your success with a local partner!",
  slide4_title: "Stronger together!",
  slide4_subtitle: "Business Development\nConsulting Services\nInterim Management\nTraining & Coaching",
  slide5_title: "Start now!",
  prev_slide: "Previous slide",
  next_slide: "Next slide",
  slide_label: "Slide {{number}}",
};

export const intro = {
  title: "NetBasis International - linking people & business",
  paragraph1:
    "Building, increasing, and/or expanding business in new markets must be promising, fast, efficient, cost-effective, and secure for foreign companies. Lengthy investigations, complicated strategy development with unclear decision-making processes, and/or the lack of direct access to these new markets, to name just a few examples, are not the right and good approach. Also, sometimes manufacturers want to try entering a new market without major investments.",
  paragraph2:
    "All these thoughts and considerations lead to {{strong}} as the right partner for you, because for more than twelve years we have been accompanying and supporting foreign companies from the telecommunications and IT industry in new attractive but also demanding markets (mainly the DACH region).",
  strong_name: "NetBasis International",
};

export const services = {
  service1_title: "Business Development",
  service1_description:
    "Do you want to expand your successful business in your home markets to new trading places, or are you looking for support with already started projects in new markets?",
  service2_title: "Consulting Services",
  service2_description:
    "Do you wish for advice in various subject areas for entering new markets, to ensure the success of your business venture, or not to jeopardize it?",
  service3_title: "Interim Management",
  service3_description:
    "Do you need very urgently and at short notice time-limited, competent help in carrying out certain tasks and/or to bridge a personnel gap?",
  service4_title: "Training & Coaching",
  service4_description:
    "Would you like to optimally prepare for the conditions of new markets, for individual constellations as well as regulatory requirements and cultural differences?",
  read_more: "Learn more",
};

export const about = {
  title: "NetBasis International - drive to excellence with excellent drivers !",
  paragraph1:
    "As recognized experts, based in Germany, the most important European market, we from {{strong}} help you to identify potential entry barriers, examine various strategic options, develop realistic marketing concepts, find suitable strategic partners, and/or approach potential customers. Focused on your success, we offer a wide range of services, including market entry and development planning, sales, marketing, public relations, technical support, and, if desired, also recruitment.",
  paragraph2:
    "When you work with us, you first have a central contact point for the entire project and, moreover, immediate access to all the necessary know-how and expertise that is indispensable for your success. With our pragmatic and results-oriented approach, we help you to work out the conditions and requirements of your target countries.",
  paragraph3:
    "And you have the choice: We can take over and fulfill individual or all local tasks of your company, and can do the actual work or the complete job for you for a fixed or indefinite period. Or we support you in a purely advisory capacity, as pure consultants, on your own way. Or you can cooperate with us for training and coaching.",
  paragraph4:
    "Whatever you choose from our services, {{strong}} will help you to coordinate all relevant means and measures.",
  strong_name: "NetBasis International",
};

export const experience = {
  title: "Experience & Track Record",
  subtitle: "Over 12 years of successful market entry and business development in the DACH region",
  stat1_value: "12+",
  stat1_label: "Years in Business",
  stat2_value: "50+",
  stat2_label: "Completed Projects",
  stat3_value: "30+",
  stat3_label: "International Clients",
  stat4_value: "4",
  stat4_label: "Core Service Areas",
  intro:
    "Since our founding, NetBasis International has been the trusted bridge for foreign ICT manufacturers entering the German-speaking markets. Our track record speaks for itself — we have repeatedly proven that with the right local partner, market entry becomes predictable, efficient, and successful.",
  timeline1_year: "2012",
  timeline1_title: "Foundation & First Projects",
  timeline1_desc: "Established NetBasis International with the vision of connecting innovative ICT companies from around the world with the DACH market. First successful market entry projects for Asian and North American manufacturers.",
  timeline2_year: "2015",
  timeline2_title: "Expanding Service Portfolio",
  timeline2_desc: "Broadened our offerings to include comprehensive consulting services, interim management, and training programs. Built a network of trusted partners across Germany, Austria, and Switzerland.",
  timeline3_year: "2018",
  timeline3_title: "International Recognition",
  timeline3_desc: "Earned recognition as a leading go-to-market partner for the DACH region. Supported clients from over 15 countries across four continents in establishing and growing their European presence.",
  timeline4_year: "2022",
  timeline4_title: "Strategic Growth & New Markets",
  timeline4_desc: "Deepened expertise in telecommunications, IT infrastructure, and digital solutions. Expanded consulting services to cover regulatory compliance, cultural adaptation, and long-term market positioning strategies.",
  timeline5_year: "2026",
  timeline5_title: "Your Partner for Tomorrow",
  timeline5_desc: "Continuing to evolve with the changing market landscape. Today, we offer a complete suite of services that helps foreign companies enter the DACH region with confidence — no risk, just results.",
};

export const contact = {
  title: "Get in touch with us directly now.",
  cta_button: "Contact Form",
};

export const footer = {
  privacy: "Privacy Policy",
  contact: "Contact",
  imprint: "Legal Notice",
  copyright: "Copyright © {{year}} NetBasis International. All rights reserved.",
};

export const pages = {
  about_title: "About Us",
  about_subtitle: "Over 12 years of market entry experience – meet the team and achievements behind NetBasis International",
  about_cta: "Ready for your market entry?",
  about_cta_button: "Get in touch now",
  about_footer_claim: "NetBasis International - drive to excellence with excellent drivers !",
  experience_title: "Experience",
  contact_title: "Contact",
  privacy_title: "Privacy Policy",
  imprint_title: "Legal Notice",
  placeholder: "This page will be filled with content shortly. We are working on it!",
};

export const aboutHero = {
  title_line1: "We make things ",
  title_line2: "happen ...",
  subtitle: "... for YOU!",
  heroAlt: "Finger touches a glowing digital point for ICT networking in the DACH market.",
};

export const aboutPage = {
  introTitle: "NetBasis International - linking people & business",
  p1: "NetBasis International was founded in early 2008 in Düsseldorf. Since then, we have been offering foreign manufacturers in the telecommunications and/or IT industry who wish to expand their business into the DACH markets or to intensify their existing activities, under the motto \"linking people & business\", any form of consultancy and commercial support as well as help in the market-specific product development or adaptation.",
  p2: "Together with our manufacturing partners, we answer all questions and work for them for exactly one concern: Success and best business results in new markets!",
  p3: "To achieve this goal, foreign companies through us get immediate access to industry-specific knowledge, years of experience and extensive contacts, with us they avoid cultural and/or linguistic barriers while being immediately present, and from us they receive prompt work on market/markets, product(s), partners and customers.",
  p4: "To strengthen existing relationships and to attract new customers and thus for the sustainable development of new markets we promote a fair and cooperative approach in all areas of sales and marketing as well as a collaborative work on challenging products and solutions (hardware and software), well adapted to the market needs.",
  p5: "Both our corporate philosophy and our ethical orientation entail that NetBasis International strategically focus on a limited number of qualified manufacturing partners who are not in competition within the industry. Because we give joint development and synergetic collaboration within the group preference over unproductive competition.",
  p6: "All this provides security for each new partner and is part of the package that we offer to you if you decide to work with us.",
  footerClaim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const aboutCards = {
  management_title: "Management",
  management_desc:
    "Christof Günther has founded NetBasis International in early 2008 and is the owner. With more than 30 years of international experience in the ICT industry, he helps foreign manufacturers to develop new markets with their products.",
  core_values_title: "Core Values",
  core_values_desc:
    "Respect. Loyalty. Professionalism. Perseverance. Confidence. These are the basic values that NetBasis International is committed to and that guide us through our daily work.",
  mission_vision_title: "Mission/Vision",
  mission_vision_desc:
    "Yes, it is always results what counts in the end. But it is always PEOPLE what matters on the way! NetBasis International enables you to easily start your business in new markets.",
  read_more: "Learn more",
};

export const aboutSubPages = {
  management: {
    title: "Management",
    heroLine1: "Driven by expertise!",
    heroLine2: "",
    heroAlt: "Hand selects a highlighted profile for competent ICT management in the DACH market.",
    p1_founded: "has founded ",
    p1_owner: "in early 2008 and is the owner.",
    p1: "Christof Günther has founded NetBasis International in early 2008 and is the owner.",
    p2: "With more than 30 years of international experience in the ICT industry, Mr. Günther helps foreign manufacturers to develop new markets with their products. In doing so, his professional focus lies on all areas of \"Business Development\" and he prepares holistic market entry concepts for and with his business partners and supports them in the implementation and control of their entire project plans.",
    p3: "He also offers interested companies his market knowledge and industry expertise via advisory mandates and/or via training and coaching.",
    p4: "Before, Mr. Günther held responsible positions (branch manager, sales manager, export manager, etc.) in medium-sized telecommunications and IT companies active in Europe and/or worldwide.",
  },
  core_values: {
    title: "Core Values",
    heroLine1: "With values",
    heroLine2: "to success!",
    heroAlt: "An open hand holds glowing digital lines symbolizing trust and values at NetBasis.",
    p1: "Respect. Loyalty. Professionalism. Perseverance. Confidence.",
    p2: "These are the basic values that NetBasis International is committed to and that guide us through our daily work. They accompany us in our responsibilities towards our business partners and guide us in the way we do our jobs.",
    p3: "It is our expectations of ourselves, to both prove to new partners that with us they have made the right choice and also to show to existing partners in new projects again and again that with us they are in good hands.",
    p4: "Your success is our commitment.",
  },
  mission_vision: {
    title: "Mission/Vision",
    heroLine1: "With teamwork",
    heroLine2: "to success!",
    heroAlt: "Team members stack their hands for joint market entry in the DACH market.",
    p1: "Yes, it is always results what counts in the end. But it is always PEOPLE what matters on the way!",
    p2: "NetBasis International enables you to easily start your business in new markets and to quickly achieve (not only first) results. With a good product/solution, we empower you to implement your strategy without delay and make it succeed. We give you the potential to be agile and competitive.",
    p3: "However, successful business cannot and will not be achieved by products/solutions alone. Products/solutions do not sell by themselves. Excellent products/solutions alone will bring no results and success.",
    p4: "Results and success, especially on the long run, start with PEOPLE and need PEOPLE. It is always PEOPLE building relationships, it is always PEOPLE working together on individual business strategies and objectives and developing the most adapted course of action to fit requirements, plans and targets. We believe in this human-centered approach and are convinced that this is what makes the difference in business.",
    p5: "That is why good and intensive collaboration is our central way to do business. Our experts join forces with your people to form a strong and close team, a team of \"drivers\" that will certainly make your market entry project a success.",
  },
};

export const experiencePage = {
  title: "Experience",
  heroClaimLine1: "Experience & Expertise",
  heroClaimLine2: "... the foundation for your success!",
  benefits_title: "What you can expect here soon",
  benefit_0: "Overview of successfully completed projects and market entries",
  benefit_1: "Customer testimonials and partnership experiences",
  benefit_2: "Detailed insights into industry and market knowledge",
  benefit_3: "Chronology and milestones of our company history",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const contactPage = {
  hero: {
    title: "We look forward to",
    subtitle: "your message!",
    heroAlt: "Two hands present a blank business card for contacting NetBasis in Düsseldorf.",
  },
  details: {
    title: "Contact Details",
    company: "NetBasis International",
    address_line1: "Heinrichstraße 45",
    address_line2: "40239 Düsseldorf",
    address_country: "Germany",
    tel_label: "Phone:",
    tel_number: "+49 (0) 211 / 544 193 80",
    fax_label: "Fax:",
    fax_number: "+49 211 54419379",
    email_label: "Email:",
    email_address: "contact@net-basis.com",
  },
  form: {
    title: "Feel free to contact us",
    name: "First name and last name",
    name_placeholder: "Your name",
    company: "Company",
    company_placeholder: "Your company",
    email: "Email Address",
    email_placeholder: "your@email.com",
    phone: "Telephone number",
    phone_placeholder: "+49 (0) ...",
    message: "Your Message",
    message_placeholder: "Your message to us...",
    dsgvo_text: "I agree that my data from the contact form will be collected and processed to answer my request. The data will be deleted after the processing of your request has been completed. You can revoke your consent for the future at any time by sending an e-mail to contact@net-basis.com. Detailed information on the handling of user data can be found in our privacy policy.",
    submit: "send",
    success_title: "Thank you!",
    success_message: "Your message has been sent successfully. We will get back to you as soon as possible.",
    error_default: "An error occurred. Please try again later.",
    spam_question: "Security check: What is",
    spam_error: "Please answer the security question.",
    spam_wrong: "That answer is incorrect. Please try again.",
  },
  map: {
    title: "Our Location",
    preview_title: "Google Maps is deactivated",
    preview_text: "When you activate Google Maps, your IP address will be transmitted to Google servers in the USA. Details can be found in our privacy policy.",
    activate_button: "Activate content",
  },
};

export const cookie_banner = {
  text: "This website uses only technically necessary cookies. No tracking or analytics cookies are used. One cookie stores your Google Maps usage preference, another serves Cloudflare bot protection.",
  privacy_link: "Learn more in our privacy policy.",
  button: "Got it",
};

export const legalPage = {
  heroAlt: "Finger touches networked § signs for NetBasis legal notice and privacy policy.",
};

export const imprintPage = {
  title: "Legal Notice",
  left_title: "Legal Notice",
  provider_title: "Info pursuant to § 5 DDG",
  provider_text: "Christof Günther\nNetBasis International\nHeinrichstraße 45\n40239 Düsseldorf\nGermany",
  contact_title: "Contact",
  phone_label: "Phone:",
  phone: "+49 (0) 211 / 544 193 80",
  email_label: "Email:",
  email: "contact@net-basis.com",
  web_label: "Internet:",
  web: "net-basis.net",
  vat_title: "VAT Identification Number",
  vat_text: "VAT identification number pursuant to § 27 a UStG:\nDE 258 486 954",
  insurance_title: "Professional Liability Insurance",
  insurance_text: "Name and registered office of the insurer:\nHiscox AG acting on behalf of Hiscox Insurance Company Ltd.\nBranch office for Germany, Arnulfstraße 31, 80636 Munich\nScope of coverage: Worldwide",
  right_title: "Disclaimer",
  disclaimer_content_title: "Liability for Content",
  disclaimer_content_text: "The contents of our website have been created with the utmost care. However, we cannot guarantee the accuracy, completeness, and timeliness of the content. As a service provider, we are responsible for our own content on these pages in accordance with general laws. We are not obligated, however, to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general laws remain unaffected. However, liability in this regard is only possible from the point in time at which we become aware of a specific infringement. Upon becoming aware of corresponding legal violations, we will remove this content immediately.",
  disclaimer_links_title: "Liability for Links",
  disclaimer_links_text: "Our offer contains links to external websites of third parties, on whose contents we have no influence. Therefore, we cannot assume any liability for these external contents. The respective provider or operator of the linked pages is always responsible for the content of the linked pages. The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognizable at the time of linking. However, a permanent content control of the linked pages is not reasonable without concrete evidence of a legal violation. Upon becoming aware of legal violations, we will remove such links immediately.",
  disclaimer_copyright_title: "Copyright",
  disclaimer_copyright_text: "The content and works created or used by us on these pages are subject to German copyright law. Reproduction, processing, distribution, and any kind of exploitation outside the limits of copyright require our consent. Downloads and copies of this site are only permitted for private, non-commercial use. Insofar as the content on our site was not created by us, the copyrights of third parties are respected. In particular, third-party content is identified as such. Should you nevertheless become aware of a copyright infringement, please inform us accordingly. Upon becoming aware of legal violations, we will remove such content immediately.",
  image_credits_title: "Image Credits",
  image_credits_intro: "The Fotolia/Adobe Stock images used on this website have been properly licensed. Please refer to the following overview for detailed copyright notices:",
  image_credits_placeholder: "Placeholder for image credits (Fotolia/Adobe Stock list)",
};

export const buttonizer = {
  trigger_label: "Contact",
  phone_label: "Call",
  email_label: "Email",
  email_address: "contact@net-basis.com",
  whatsapp_label: "WhatsApp",
  whatsapp_link: "https://wa.me/4915126386361",
  telegram_label: "Telegram",
  telegram_link: "https://t.me/ChriGue1",
  signal_label: "Signal",
  signal_link: "https://signal.me/#p/+4915126386361",
  messenger_label: "Messenger",
  messenger_link: "https://m.me/ChriGue1",
  phone_number: "+4921154419380",
  phone_display: "+49 (0) 211 / 544 193 80",
};

export const notFound = {
  title: "This page has not been generated",
  message: "Tell us more about this page, so we can generate it for you.",
};